import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import { E取込データ種別 } from '@/openapi/enum';
import { 取込XlsxImportListItemResponse } from '@/openapi/user';

import 取込Mixin from '@/entries/user/mixins/取込Mixin';

export default mixins(取込Mixin).extend({
  name: 'Xlsxデータ確認Tab',

  props: {
    xlsxImport: {
      type: Object as PropType<取込XlsxImportListItemResponse>,
    },
  },

  data(): {
    readonly insert勘定科目Index: number;
  } {
    return {
      insert勘定科目Index: 2,
    };
  },

  computed: {
    header(): string[] {
      const header = this.xlsxImport.header!;
      if (this.xlsxImport.取込データ種別 === E取込データ種別.固定資産台帳) {
        return [...header.slice(0, this.insert勘定科目Index), '科目名', ...header.slice(this.insert勘定科目Index)];
      } else {
        return ['', ...header];
      }
    },
    list(): string[][] {
      if (this.xlsxImport.取込データ種別 === E取込データ種別.固定資産台帳) {
        return this.xlsxImport.list.map((row) => [
          ...row.values.slice(0, this.insert勘定科目Index),
          this.get取込勘定科目(row),
          ...row.values.slice(this.insert勘定科目Index),
        ]);
      } else {
        return this.xlsxImport.list.map((row) => [this.get取込勘定科目(row), ...row.values]);
      }
    },
  },
});
